import { Center, Text } from '@chakra-ui/react';
import { Modal } from '@diamond/shared/ui';

export interface CartDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const CartDeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
}: CartDeleteModalProps) => {
  return (
    <Modal
      name="delete-all-product"
      labelCancel="Kembali"
      labelSubmit="Hapus"
      buttonColor="red"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onConfirm}
      isCentered
    >
      <Center>
        <Text m="10" align="center" fontSize="2xl" as="b">
          Apakah Anda yakin Ingin menghapus semua isi keranjang ?
        </Text>
      </Center>
    </Modal>
  );
};
